/*
    Store module getters examples

*/

// Start new mutation here
export function newGetter(state) {
  return state;
}
